import AGREGAR_TIPO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/tipoarchivoscontratista/agregarCatalogoTipoArchivoContratista.gql';
import ACTUALIZAR_TIPO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/tipoarchivoscontratista/actualizarCatalogoTipoArchivoContratista.gql';
import REMOVER_TIPO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/tipoarchivoscontratista/removerCatalogoTipoArchivoContratista.gql';
import CATALOGO_TIPO_ARCHIVO_CONTRATISTA from '@/graphql/querys/administracion/contratos/contrato/archivos-contratista/tipos-archivivos-contratista/catalogoTiposArchivosContratista.gql';

export default {
  methods: {
    // Agregar Tipo de Archivo Contratista
    async mixAgregarTipoArchivoContratista() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_TIPO_ARCHIVO_CONTRATISTA,
          variables: {
            tipoArchivo: this.tipoArchivo,
          },
          update: (store, { data: { agregarCatalogoTipoArchivoContratista } }) => {
            const query = {
              query: CATALOGO_TIPO_ARCHIVO_CONTRATISTA,
            };
            const { catalogoTiposArchivosContratista } = store.readQuery(query);
            const catalogoCopia = catalogoTiposArchivosContratista.slice();
            catalogoCopia.push(agregarCatalogoTipoArchivoContratista);
            store.writeQuery({
              ...query,
              data: {
                catalogoTiposArchivosContratista: catalogoCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Tipo de Archivo Contratista
    async mixActualizarTipoArchivoContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_TIPO_ARCHIVO_CONTRATISTA,
          variables: {
            id: this.tipoArchivoContratistaEditar.id,
            tipoArchivo: this.tipoArchivo,
          },
          update: (store, { data: { actualizarCatalogoTipoArchivoContratista } }) => {
            const query = {
              query: CATALOGO_TIPO_ARCHIVO_CONTRATISTA,
            };
            const data = store.readQuery(query);
            const { catalogoTiposArchivosContratista } = data;
            const index = catalogoTiposArchivosContratista.findIndex(
              (tipoArchivo) => tipoArchivo.id === actualizarCatalogoTipoArchivoContratista.id,
            );
            if (index !== -1) {
              catalogoTiposArchivosContratista.splice(
                index,
                1,
                actualizarCatalogoTipoArchivoContratista,
              );
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Tipo de Archivo Contratista
    async mixEliminarTipoArchivoContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_TIPO_ARCHIVO_CONTRATISTA,
          variables: {
            id: this.tipoArchivoContratistaEliminar.id,
          },
          update: (store) => {
            const query = {
              query: CATALOGO_TIPO_ARCHIVO_CONTRATISTA,
            };
            const data = store.readQuery(query);
            const { catalogoTiposArchivosContratista } = data;
            const index = catalogoTiposArchivosContratista.findIndex(
              (tipoArchivo) => tipoArchivo.id === this.tipoArchivoContratistaEliminar.id,
            );
            if (index !== -1) {
              catalogoTiposArchivosContratista.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
